import {Growth} from '@carbon/icons-react';
import Text from './Text';
import {
  CompareChangesWrapper,
  ChangesTexts,
  EndIcon,
} from '@atoms/CoverageChanges.styles';
import {theme} from '@styles/theme';
import {PageSubtitleLegendMark} from '@components/organisms/PageSubtitleBlock.styles';

export const CoverageChanges = ({
  coverage,
  changes,
  variant = 'inline',
  mark = 'empty',
}: {
  coverage: number | undefined;
  changes: number | undefined;
  variant?: 'inline' | 'stacked';
  mark?: 'manual' | 'auto' | 'empty';
}) => {
  const formatter = new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const value = typeof changes === 'number' ? changes : 0;
  const isPositive = value > 0;
  const isNegative = value < 0;
  const coverageValue = typeof coverage === 'number' ? coverage : 0;
  const numericCoverage = formatter.format(Math.abs(coverageValue));
  const paddedNumericCoverage =
    Math.abs(coverageValue) < 10 ? `0${numericCoverage}` : numericCoverage;
  const formattedCoverage = `${paddedNumericCoverage}%`;
  const sign = isPositive ? '+' : isNegative ? '-' : '';
  const numericChanges = formatter.format(Math.abs(value));
  const paddedNumericChanges =
    Math.abs(value) < 10 ? `0${numericChanges}` : numericChanges;
  const formattedChanges = `${sign}${paddedNumericChanges}%`;
  const changesColor = isPositive
    ? theme.colors.signalGreen00
    : isNegative
      ? theme.colors.signalRed00
      : theme.colors.basic03;

  const isStacked = variant === 'stacked';

  return (
    <CompareChangesWrapper $stacked={isStacked}>
      <ChangesTexts $stacked={isStacked}>
        {mark === 'manual' && <PageSubtitleLegendMark color={theme.colors.manual00} />}
        {mark === 'auto' && <PageSubtitleLegendMark color={theme.colors.auto00} />}
        <Text
          text={isStacked ? '\u00A0' + formattedCoverage : formattedCoverage}
          type="bodyNum"
        />
        <Text
          text={!sign && isStacked ? '\u00A0' + formattedChanges : formattedChanges}
          type="bodyNum"
          color={changesColor}
        />
      </ChangesTexts>
      <EndIcon $stacked={isStacked}>
        {isPositive && <Growth fill={theme.colors.signalGreen00} />}
        {isNegative && (
          <Growth fill={theme.colors.signalRed00} style={{transform: 'scaleY(-1)'}} />
        )}
      </EndIcon>
    </CompareChangesWrapper>
  );
};
